<div class="holder" (click)="doAanimate()">
<svg viewBox="0 0 100 100" [ngClass]="animate" >
  <g>
    <path id="lane" d="M 50 12 A 38 38 0 0 1 50 88    38 38 0 0 1 50 12" />
    <path id="ring1" d="M 50 05 A 45 45 0 0 1 50 95    38 38 0 0 1 50 05" />
    <path id="ring2" d="M 50 12 A 38 38 0 0 1 50 88    38 38 0 0 1 50 12" />
    <path id="ring3" d="M 50 19 A 31 31 0 0 1 50 81    31 31 0 0 1 50 19" />
  </g>
</svg>
<div class="label">{{label}}</div>
<div class="text">{{text}}</div>
</div>
